import '../css/app.css';
import './bootstrap';

import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';

// Track Inertia SPA navigations in Google Analytics
router.on('navigate', () => {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'page_view', {
            page_location: window.location.href,
            page_title: document.title,
        });
    }
});

const appName = import.meta.env.VITE_APP_NAME || 'AntonetShop Jamaica';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
